import { Typography, Box } from '@mui/material';
import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';

import { useStyles } from './useStyles';

interface IImageTextSection {
  slice: any;
}

const ImageTextSection = ({ slice }: IImageTextSection) => {
  const { primary, variation } = slice || {};

  const { rich_text, image_caption, image } = primary || {};
  const { url, alt, dimensions } = image || {};
  const { width, height } = dimensions || {};
  const getClasses = useStyles({ variation });
  const classes = getClasses();
  const SECOND_VARIATION = 'imageOnRightSide';

  return (
    <Box className={classes.mainContainer}>
      <Box className={classes.container}>
        <Box className={classes.imgSection}>
          <Box className={classes.imgWrapper}>
            {url ? (
              <Image
                src={url}
                alt={alt || 'Image'}
                objectFit="contain"
                layout="fill"
              />
            ) : null}
          </Box>
          {image_caption ? (
            <Typography variant="body2" textAlign="center" color="cumin.main">
              {image_caption}
            </Typography>
          ) : null}
        </Box>
        <Box className={classes.textWrapper}>
          <PrismicRichText
            field={rich_text}
            components={{
              heading3: ({ children }) => (
                <Typography variant="h3" color="cinnamon.main">
                  {children}
                </Typography>
              ),
              paragraph: ({ children }) => (
                <Typography
                  variant="body2"
                  align="justify"
                  color="garamMasala.main"
                  mb="15px"
                >
                  {children}
                </Typography>
              ),
              oList: ({ children }) => {
                return <ol>{children}</ol>;
              },
              oListItem: ({ children }) => {
                return (
                  <li className={classes.listItem}>
                    <Typography
                      variant="body2"
                      align="justify"
                      color="garamMasala.main"
                    >
                      {children}
                    </Typography>
                  </li>
                );
              },
              list: ({ children }) => {
                return <ul className={classes.unorderedlist}>{children}</ul>;
              },
              listItem: ({ children }) => {
                return (
                  <li className={classes.unorderedlistItem}>
                    <Typography
                      component={'span'}
                      variant="body2"
                      align="justify"
                      color="garamMasala.main"
                    >
                      {children}
                    </Typography>
                  </li>
                );
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ImageTextSection;
